// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__3wzA0","tab":"Tabs_tab__Xd_5o","active":"Tabs_active__2EGbE"};